/* /nat-type-test — page controller. Measuring: public/js/nat-probe.js (NatProbe). Meaning (verdict,
   ranked to-do, letter asks, console comparison): public/js/nat-type-test/advice.js (NatAdvice).
   This file only runs the test and draws the page. docs/why/nat-type-test.md.

   Round 2 (04.11.2026, independent QA audit): the verdict appears where the person is looking (the
   hero becomes the summary, the NAT cards fill in as soon as the NAT phase ends), Run and Stop are
   two buttons (a double-click no longer starts and stops), the screen reader hears phases, not 240
   counters, every await is bounded, a stopped or interrupted line is never graded as a full one,
   history keeps numbers, the five tools become tabs on a wide screen. */
(function () {
    'use strict';
    var SLUG = 'nat-type-test';
    var CFG = window.__NTT || { T: {} };
    var T = CFG.T || {};
    var $ = function (id) { return document.getElementById(id); };
    var root = $('ntt');
    if (!root) return;
    var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    function tr(key, rep) {
        var s = T[key] != null ? String(T[key]) : key;
        if (rep) Object.keys(rep).forEach(function (k) { s = s.split(':' + k).join(rep[k]); });
        // a number keeps its unit on the same line ("0,2 %", "12 мс")
        return s.replace(/(\d) (%|[^\s\d.,;:!?()]{1,3}(?=$|[\s.,;:)]))/g, '$1 $2');
    }
    function has(key) { return T[key] != null; }
    function loc() { return window.__intlLocale ? window.__intlLocale() : undefined; }
    function fmt(n, d) {
        if (n == null || isNaN(n)) return '—';
        try { return Number(n).toLocaleString(loc(), { maximumFractionDigits: d == null ? 0 : d, minimumFractionDigits: 0 }); }
        catch (_) { return String(Math.round(n)); }
    }
    function pct(q) { return q.lost === 0 && q.lossUpperPct != null ? tr('m_loss_upper', { v: fmt(q.lossUpperPct, 1) }) : tr('m_pct', { v: fmt(q.lossPct, 2) }); }
    function ms(v) { return tr('m_ms', { v: fmt(v) }); }
    function ae(type, p) { try { if (window.__ae) window.__ae(type, Object.assign({ slug: SLUG }, p || {})); } catch (_) {} }
    function feature(f, p) { ae('feature_use', Object.assign({ f: f }, p || {})); }
    function stage(name, meta) { try { if (window.__stage) window.__stage(name, meta || {}); } catch (_) {} }
    function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (_) {} }
    function copy(text) {
        return new Promise(function (resolve) {
            var ok = function () { toast(tr('copied'), 'success'); resolve(true); };
            var bad = function () { toast(tr('copy_failed'), 'warning'); resolve(false); };
            var fallback = function () {
                try {
                    var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
                    ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
                    var done = document.execCommand('copy'); ta.remove(); if (done) ok(); else bad();
                } catch (_) { bad(); }
            };
            try { if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(ok, fallback); return; } } catch (_) {}
            fallback();
        });
    }
    function region() {
        var r = window.__WebRTC && window.__WebRTC.REGION;
        return r === 'ru' ? 'ru' : (r === 'intl' ? 'intl' : (CFG.locale === 'ru' ? 'ru' : 'intl'));
    }
    function conn() {
        var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        return c && c.type ? c.type : null;
    }
    function sstore(op, key, val) {
        try {
            if (op === 'get') return JSON.parse(localStorage.getItem(key) || 'null');
            localStorage.setItem(key, JSON.stringify(val)); return true;
        } catch (_) { return op === 'get' ? null : false; }
    }

    /* ---------- state ---------- */
    var LAST_KEY = 'ntt_last_v1', LAST_TTL = 48 * 3600e3;
    var S = { running: false, phase: 'idle', ctrl: null, res: null, A: null, wan: null, wanValue: '', wanOut: null, consolePick: null,
              duration: 30, shared: false, runN: 0, hiddenMs: 0, hiddenAt: null, startedAt: 0, prev: null };
    var settings = window.__toolSettings;
    if (settings) {
        S.duration = settings.load(SLUG, 'duration', 30) === 120 ? 120 : 30;
        var lc = $('nttLoad'); if (lc) lc.checked = !!settings.load(SLUG, 'load', false);
    }

    /* ---------- the network the person is on ---------- */
    (function netBadge() {
        var el = $('nttNet'); if (!el) return;
        var c = conn(), map = { wifi: 'net_wifi', ethernet: 'net_ethernet', cellular: 'net_cellular' };
        if (c && map[c]) { el.textContent = tr(map[c]); el.dataset.kind = c; el.hidden = false; }
        else if (IOS) { el.textContent = tr('ios_hint'); el.dataset.kind = 'ios'; el.hidden = false; }
        if (c === 'cellular') {            // the load option would spend mobile data on a measurement of the wrong network
            var lb = $('nttLoad'); if (lb) { lb.checked = false; lb.disabled = true; }
            var ln = $('nttLoadNote'); if (ln) ln.textContent = tr('load_cellular');
        }
    })();

    /* ---------- duration ---------- */
    var durBtns = root.querySelectorAll('[data-dur]');
    function paintDur() { durBtns.forEach(function (b) { var on = +b.dataset.dur === S.duration; b.setAttribute('aria-pressed', String(on)); b.classList.toggle('on', on); }); }
    durBtns.forEach(function (b) {
        b.addEventListener('click', function () {
            if (S.running) return;
            S.duration = +b.dataset.dur === 120 ? 120 : 30; paintDur();
            if (settings) settings.save(SLUG, 'duration', S.duration);
        });
    });
    paintDur();
    var loadBox = $('nttLoad');
    if (loadBox) loadBox.addEventListener('change', function () { if (settings) settings.save(SLUG, 'load', loadBox.checked); });

    /* ---------- diagram + steps ---------- */
    function node(name, state, badge) {
        var n = root.querySelector('[data-node="' + name + '"]'); if (!n) return;
        if (state) n.dataset.state = state; else delete n.dataset.state;
        var b = n.querySelector('.ntt-badge');
        if (b) { if (badge) { b.textContent = badge; b.hidden = false; } else b.hidden = true; }
    }
    function link(name, state) {
        var l = root.querySelector('[data-link="' + name + '"]'); if (!l) return;
        if (state) l.dataset.state = state; else delete l.dataset.state;
    }
    function step(name, state, text) {
        var li = root.querySelector('[data-step="' + name + '"]'); if (!li) return;
        li.dataset.state = state;
        li.querySelector('span').textContent = text != null ? text : (state === 'run' ? tr('st_run') : state === 'skip' ? tr('st_skip') : tr('st_wait'));
    }
    function resetDiagram() {
        ['device', 'router', 'isp', 'server'].forEach(function (n) { node(n, null); });
        ['lan', 'wan', 'net'].forEach(function (l) { link(l, null); });
        ['udp', 'map', 'filter', 'hairpin', 'line'].forEach(function (s) { step(s, 'wait'); });
    }
    // what you SEE changes every tick; what a screen reader HEARS changes per phase (QA M9)
    function status(text) { var s = $('nttStatus'); if (s) s.textContent = text; }
    function announce(text) { var a = $('nttAnnounce'); if (a) { a.textContent = ''; setTimeout(function () { a.textContent = text; }, 30); } }

    /* ---------- the live chart (inside the line card) ---------- */
    var chart = { series: {}, seconds: 30 };
    function chartColors() {
        var cs = getComputedStyle(root);
        return { a: cs.getPropertyValue('--ntt-run').trim() || '#7c8cff', b: cs.getPropertyValue('--ntt-b').trim() || '#9aa3b2',
                 bad: cs.getPropertyValue('--ntt-bad').trim() || '#ef4444', grid: cs.getPropertyValue('--border').trim() || 'rgba(127,127,127,.25)',
                 text: cs.getPropertyValue('--text-muted').trim() || '#888' };
    }
    function drawChart() {
        var c = $('nttChart'); if (!c || !c.clientWidth) return;
        var dpr = Math.min(2, window.devicePixelRatio || 1), w = c.clientWidth, h = c.clientHeight || 120;
        if (c.width !== Math.round(w * dpr) || c.height !== Math.round(h * dpr)) { c.width = Math.round(w * dpr); c.height = Math.round(h * dpr); }
        var g = c.getContext('2d'); if (!g) return;
        g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, w, h);
        var col = chartColors(), keys = Object.keys(chart.series), maxT = chart.seconds * 1000;
        var hi = 0; keys.forEach(function (k) { chart.series[k].forEach(function (p) { if (p.lat != null && p.lat > hi) hi = p.lat; }); });
        if (!hi) return;
        // an honest axis: from 0, so a 5 ms wobble on a 300 ms line does not look like a storm (QA m14)
        hi = Math.max(50, Math.ceil(hi * 1.1 / 50) * 50);
        var padB = 18, padT = 16, x = function (t) { return Math.min(w, t / maxT * w); }, y = function (v) { return padT + (1 - v / hi) * (h - padB - padT); };
        g.strokeStyle = col.grid; g.lineWidth = 1;
        [0, 0.5, 1].forEach(function (f) { var Y = Math.round(y(hi * f)) + 0.5; g.beginPath(); g.moveTo(0, Y); g.lineTo(w, Y); g.stroke(); });
        g.fillStyle = col.text; g.font = '12px system-ui, sans-serif'; g.textBaseline = 'top';
        try { g.direction = 'ltr'; } catch (_) {} g.textAlign = 'left';   // an RTL page would draw the label off the left edge
        g.fillText(ms(hi), 4, 1);
        keys.forEach(function (k, i) {
            var pts = chart.series[k];
            g.strokeStyle = i === 0 ? col.a : col.b; g.lineWidth = 2; g.beginPath();
            var started = false;
            pts.forEach(function (p) { if (p.lat == null) return; var X = x(p.t), Y = y(p.lat); if (!started) { g.moveTo(X, Y); started = true; } else g.lineTo(X, Y); });
            g.stroke();
            g.fillStyle = col.bad;
            pts.forEach(function (p) { if (p.lost > 0) g.fillRect(x(p.t) - 1.5, h - padB + 4 + i * 6, 3, 5); });
        });
    }
    var drawPending = false;
    function scheduleDraw() { if (drawPending) return; drawPending = true; requestAnimationFrame(function () { drawPending = false; drawChart(); }); }
    window.addEventListener('resize', scheduleDraw);
    function legend(regs) {
        var el = $('nttLegend'); if (!el) return;
        var col = chartColors();
        el.textContent = '';
        regs.forEach(function (r, i) {
            var s = document.createElement('span'), dot = document.createElement('i');
            dot.style.background = i === 0 ? col.a : col.b; s.appendChild(dot);
            s.appendChild(document.createTextNode(tr('path_row', { city: tr('city_' + r) })));
            el.appendChild(s);
        });
        var lossKey = document.createElement('span'), lk = document.createElement('i');
        lk.className = 'ntt-lk'; lossKey.appendChild(lk); lossKey.appendChild(document.createTextNode(tr('legend_loss')));
        el.appendChild(lossKey);
    }

    /* ---------- run / stop ---------- */
    var runBtn = $('nttRun'), stopBtn = $('nttStop');
    var BLOCKED = { blocked: 1, firewall: 1, browser: 1, offline: 1 };
    function setRunning(on) {
        S.running = on;
        runBtn.hidden = on;
        stopBtn.hidden = !on;
        runBtn.textContent = S.res && !S.shared ? tr('btn_again') : tr('btn_run');
        durBtns.forEach(function (b) { b.disabled = on; });
        if (loadBox && conn() !== 'cellular') loadBox.disabled = on;
        root.dataset.phase = on ? S.phase : (S.res ? 'done' : 'idle');
    }
    function audioContext() {
        try {
            var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null;
            var ctx = new AC(); if (ctx.resume) ctx.resume().catch(function () {});
            return ctx;
        } catch (_) { return null; }
    }
    function onVisibility() {
        if (!S.running) return;
        if (document.visibilityState === 'hidden') S.hiddenAt = Date.now();
        else if (S.hiddenAt) { S.hiddenMs += Date.now() - S.hiddenAt; S.hiddenAt = null; }
    }
    document.addEventListener('visibilitychange', onVisibility);

    runBtn.addEventListener('click', function () { start(); });
    stopBtn.addEventListener('click', function () {
        // the second click of a double-click lands where Run was: ignore Stop for its first second (QA M6)
        if (!S.running || Date.now() - S.startedAt < 1000) return;
        if (S.ctrl) S.ctrl.abort();
    });

    function start() {
        if (S.running) return;
        if (!window.NatProbe || !window.NatAdvice || typeof window.RTCPeerConnection !== 'function') {
            status(tr('err_no_rtc')); announce(tr('err_no_rtc')); ae('tool_error', { reason: 'no_rtc' }); return;
        }
        var ctx = audioContext();                      // inside the click: browsers start audio only on a gesture
        S.phase = 'nat'; S.startedAt = Date.now();
        // read the option BEFORE setRunning disables the box (a disabled box read as "off": the load never ran)
        S.useLoad = !!(loadBox && loadBox.checked && conn() !== 'cellular');
        setRunning(true);
        // paint the button swap first, then do the heavy part (QA m18: 300 ms to next paint)
        requestAnimationFrame(function () { setTimeout(function () { run(ctx); }, 0); });
    }

    async function run(ctx) {
        S.ctrl = new AbortController(); var signal = S.ctrl.signal;
        S.hiddenMs = 0; S.hiddenAt = document.visibilityState === 'hidden' ? Date.now() : null;
        S.runN++; S.prev = sstore('get', LAST_KEY);
        if (S.shared) leaveShared();
        var reg = region(), regs = reg === 'ru' ? ['ru', 'intl'] : ['intl'];
        var useLoad = S.useLoad;
        var t0 = Date.now();
        try { if (window.__wakeLock) window.__wakeLock.request(); } catch (_) {}
        resetDiagram();
        paintPhase('nat');
        $('nttSteps').hidden = false; $('nttSteps').open = true;
        chart.series = {}; chart.seconds = S.duration; regs.forEach(function (r) { chart.series[r] = []; }); legend(regs);
        stage('probe_start', { dur: S.duration, load: useLoad ? 1 : 0, region: reg });
        ae('tool_use', { dur: S.duration, load: useLoad ? 1 : 0, conn: conn() || '', ios: IOS ? 1 : 0 });
        node('device', 'run'); link('lan', 'run'); link('wan', 'run'); link('net', 'run');
        status(tr('status_nat')); announce(tr('status_nat'));
        var res = { at: Date.now(), region: reg, dur: S.duration, load: useLoad };
        S.res = null; S.A = null;
        var stoppedPhase = null;
        try {
            var n = await NatProbe.nat({
                region: reg, signal: signal,
                onStep: function (name, st, data) {
                    if (st === 'run') { step(name, 'run'); return; }
                    if (st === 'skip') { step(name, 'skip'); return; }
                    paintStep(name, data);
                }
            });
            if (signal.aborted) { stoppedPhase = 'nat'; throw stopErr(); }
            res.n = slimNat(n);
            var natMs = Date.now() - t0;
            stage('nat_done', { ms: natMs, map: res.n.mapping && res.n.mapping.kind, filt: res.n.filtering && res.n.filtering.kind,
                hp: res.n.hairpin, retried: n.filterRetried ? 1 : 0, udp: res.n.udp, ipv6: res.n.ipv6 == null ? 'na' : (res.n.ipv6 ? 1 : 0),
                bases: n.mapping && n.mapping.bases, ifaces: n.mapping && n.mapping.ifaces,
                stun: (n.stun || []).map(function (s) { return s.host.split('.')[0] + (s.ok ? 1 : 0); }).join(',') });
            var svP = NatProbe.serverView(n.publicIp, signal, 5000);

            // the NAT verdict now, the line later: the cards fill in after ~8 s instead of after 40 s
            S.res = res; renderNatEarly();
            // the device is at fault only when its browser hid the addresses; a network that blocks UDP is the link's
            node('device', res.n.udp === 'browser' ? 'bad' : (res.n.udp === 'offline' ? null : 'good'));

            if (res.n.udp === 'ok') {
                // A context the browser kept suspended or 'interrupted' (a call on iOS) would send no
                // audio and read as 100 % loss — try once more, then skip the line with the reason.
                if (ctx && ctx.state !== 'running') { try { await Promise.race([ctx.resume(), new Promise(function (r) { setTimeout(r, 800); })]); } catch (_) {} }
                if (!ctx || ctx.state !== 'running') {
                    res.q = regs.map(function (r) { return { region: r, ok: false, why: ctx && ctx.state === 'interrupted' ? 'audio_interrupted' : 'audio_blocked' }; });
                    ae('tool_error', { reason: 'line_failed', why: res.q[0].why });
                } else {
                    S.phase = 'line'; root.dataset.phase = 'line'; paintPhase('line');
                    step('line', 'run', tr('st_line_live', { lost: 0, total: 0 }));
                    node('server', 'run');
                    stage('line_start', { regions: regs.join(','), dur: S.duration, load: useLoad ? 1 : 0 });
                    announce(tr('status_line_start', { s: S.duration }));
                    var totals = {};
                    var qs = await Promise.all(regs.map(function (r, i) {
                        return NatProbe.quality({
                            region: r, seconds: S.duration, audioCtx: ctx, signal: signal,
                            load: useLoad && i === 0, loadAfterMs: Math.round(S.duration * 1000 * 0.4), loadCapBytes: (CFG.loadMb || 300) * 1e6,
                            onTick: function (tk) {
                                chart.series[r].push(tk.point); scheduleDraw();
                                totals[r] = tk;
                                var a = totals[regs[0]] || { lost: 0, recv: 0 };
                                var left = Math.max(0, Math.ceil(tk.seconds - tk.elapsed));
                                step('line', 'run', tr('st_line_live', { lost: fmt(a.lost), total: fmt(a.lost + a.recv) }));
                                status(tr('status_line', { lost: fmt(a.lost), total: fmt(a.lost + a.recv), s: left }));
                                var lv = $('nttLineLive'); if (lv) lv.textContent = tr('line_live', { lost: fmt(a.lost), total: fmt(a.lost + a.recv), s: left });
                            }
                        });
                    }));
                    res.q = qs.map(slimQ);
                    res.q.forEach(function (q) { if (!q.ok && q.why !== 'aborted') ae('tool_error', { reason: 'line_failed', region: q.region, why: q.why, setup_ms: q.setupMs || null }); });
                    if (signal.aborted) { res.stoppedLine = true; res.stoppedSecs = (res.q[0] && res.q[0].seconds) || 0; stoppedPhase = 'line'; }
                }
            }
            if (S.hiddenAt) { S.hiddenMs += Date.now() - S.hiddenAt; S.hiddenAt = Date.now(); }
            res.hiddenMs = S.hiddenMs;
            var sv = await svP;                                     // bounded inside (5 s)
            if (sv && sv.failed) { if (sv.failed === 'timeout') ae('tool_error', { reason: 'sv_timeout' }); res.sv = null; }
            else res.sv = sv;
            S.res = res;
            render(true);
            if (stoppedPhase) {
                feature('stopped', { phase: stoppedPhase, secs: res.stoppedSecs || 0 });
                announce(tr('stopped_line'));
            } else {
                complete(res, t0);
            }
        } catch (e) {
            if (e && e.stopped) {
                feature('stopped', { phase: 'nat', secs: Math.round((Date.now() - t0) / 1000) });
                S.res = null; S.A = null;
                resetDiagram(); $('nttSteps').hidden = true;
                restoreIdle(); status(tr('stopped')); announce(tr('stopped'));
            } else {
                status(tr('err_generic')); announce(tr('err_generic'));
                try { if (window.__handleError) window.__handleError(e, 'nat_type_test_run', { say: tr('err_generic') }); } catch (_) {}
            }
        } finally {
            try { if (ctx && ctx.close) ctx.close(); } catch (_) {}
            try { if (window.__wakeLock) window.__wakeLock.release(); } catch (_) {}
            S.phase = S.res ? 'done' : 'idle';
            setRunning(false);
            ['lan', 'wan', 'net'].forEach(function (l) { var el = root.querySelector('[data-link="' + l + '"]'); if (el && el.dataset.state === 'run') delete el.dataset.state; });
            ['device', 'router', 'isp', 'server'].forEach(function (nn) { var el = root.querySelector('[data-node="' + nn + '"]'); if (el && el.dataset.state === 'run') delete el.dataset.state; });
            if (S.res) $('nttSteps').open = false;
        }
    }
    function stopErr() { var e = new Error('stopped'); e.stopped = true; return e; }

    function paintStep(name, n) {
        if (name === 'udp') {
            var u = n.udp;
            if (u === 'ok') step('udp', 'good', tr('st_udp_ok'));
            else step('udp', u === 'browser' ? 'ok' : 'bad', tr('st_udp_' + u));
        } else if (name === 'map') {
            var k = n.mapping.kind;
            step('map', k === 'independent' ? 'good' : (k === 'unknown' || k === 'interfaces' ? 'ok' : 'bad'), tr('st_map_' + k));
        } else if (name === 'filter') {
            var f = n.filtering.kind;
            step('filter', f === 'open' ? 'good' : (f === 'unknown' ? 'skip' : 'ok'), tr('st_filter_' + f));
        } else if (name === 'hairpin') {
            step('hairpin', n.hairpin === 'yes' ? 'good' : (n.hairpin === 'no' ? 'ok' : 'skip'), tr('st_hairpin_' + n.hairpin));
        }
    }

    function slimNat(n) {
        return {
            udp: n.udp, tcpRelay: !!n.tcpRelay, publicIp: n.publicIp || '',
            mapping: n.mapping ? { kind: n.mapping.kind, servers: n.mapping.servers, portPreserved: n.mapping.portPreserved, confident: n.mapping.confident, ifaces: n.mapping.ifaces } : null,
            filtering: n.filtering ? { kind: n.filtering.kind } : null,
            hairpin: n.hairpin || 'unknown', ipv6: n.ipv6 == null ? null : !!n.ipv6,
            stun: (n.stun || []).map(function (s) { return { host: s.host, ok: s.ok, ms: s.rttMs }; }),
            rtc: n.rtc
        };
    }
    function slimQ(q) {
        if (!q || !q.ok) return { region: q && q.region, ok: false, why: q && q.why, setupMs: q && q.setupMs };
        return {
            region: q.region, ok: true, seconds: q.seconds, total: q.total, lost: q.lost, lossPct: q.lossPct, lossUpperPct: q.lossUpperPct,
            jitterMs: q.jitterMs, latency: { p50: q.latency.p50, p95: q.latency.p95, max: q.latency.max, n: q.latency.n },
            spikes: q.spikes, maxBurst: q.maxBurst, stopped: !!q.stopped,
            loaded: q.loaded, loadBytes: q.loadBytes, quietP50: q.quietP50, loadedP50: q.loadedP50, loadedSamples: q.loadedSamples, loadCapHit: q.loadCapHit
        };
    }

    /* ---------- render ---------- */
    var PS5_LEVEL = { type1: 'good', type2: 'good', type3: 'bad', fail: 'bad' };
    var XBOX_LEVEL = { open: 'good', moderate: 'ok', strict: 'bad' };
    function actx() { return { wan: S.wan ? { kind: S.wan } : null, conn: S.shared ? null : conn() }; }

    function paintPhase(ph) {
        root.dataset.phase = ph;
        if (ph === 'nat') {
            ['nttPs5', 'nttXbox'].forEach(function (id) {
                var c = $(id); c.dataset.level = 'pending';
                c.querySelector('[data-v]').textContent = tr('st_run');
                c.querySelector('[data-n]').textContent = tr('card_pending');
                c.querySelector('[data-u]').hidden = true;
            });
            $('nttSummary').hidden = true; $('nttTodoBox').hidden = true; $('nttDetailsBox').hidden = true; $('nttRetest').hidden = true;
            $('nttNetNote').hidden = true;
            $('nttLine').hidden = false; $('nttLine').dataset.state = 'wait'; $('nttLineFinal').hidden = true; $('nttLineLive').textContent = tr('line_wait');
            $('nttGrade').textContent = ''; $('nttLineRetry').hidden = true; $('nttLoadRes').hidden = true; $('nttPaths').textContent = '';
            drawChart();
        } else if (ph === 'line') {
            $('nttLine').dataset.state = 'run';
            $('nttLineLive').textContent = tr('line_live', { lost: 0, total: 0, s: S.duration });
        }
    }

    function renderNatEarly() {
        var A = NatAdvice.assess({ n: S.res.n, q: [], sv: null }, actx());
        paintCards(A);
        // the hero (where the person pressed Run) already shows the NAT answer while the line runs
        paintSumChips(A);
        var waitLine = S.res.n.udp === 'ok';
        $('nttSumLine').textContent = waitLine ? tr('sum_line_wait') : ''; $('nttSumLine').hidden = !waitLine;
        $('nttSumFirstRow').hidden = true;
        $('nttSummary').hidden = false;
        announce(tr('announce_nat', { ps5: tr('ps5_' + A.verdict.ps5.plain), xbox: tr('xbox_' + A.verdict.xbox.plain) }));
    }

    function paintCards(A) {
        paintConsole($('nttPs5'), 'ps5', A.verdict.ps5, PS5_LEVEL, A);
        paintConsole($('nttXbox'), 'xbox', A.verdict.xbox, XBOX_LEVEL, A);
        var netNote = $('nttNetNote');
        var nk = { cellular: 'net_note_cellular', vpn: 'net_note_vpn', relay_http: 'net_note_relay', browser: 'net_note_browser' }[A.net];
        if (nk) { netNote.textContent = tr(nk); netNote.hidden = false; } else netNote.hidden = true;
    }

    // speak: announce the result (only when a run just finished — a WAN check or a shared link re-renders silently)
    function render(speak) {
        var res = S.res; if (!res || !res.n) return;
        var A = S.A = NatAdvice.assess(res, actx());
        var n = res.n || {};
        paintCards(A);

        // diagram after the run
        var m = n.mapping ? n.mapping.kind : 'unknown', f = n.filtering ? n.filtering.kind : 'unknown';
        var rState = BLOCKED[n.udp] ? null : (m === 'dependent' || m === 'multi') ? 'bad' : (f === 'open' ? 'good' : (m === 'independent' ? 'ok' : null));
        if (n.udp === 'blocked' || n.udp === 'firewall') link('wan', 'bad');
        if (n.udp === 'browser') node('device', 'bad', '!');
        if (n.udp === 'offline') link('lan', 'bad');
        node('router', A.net === 'cellular' || A.net === 'vpn' ? null : rState, rState === 'bad' ? '!' : null);
        var ispBad = S.wan === 'cgnat' || S.wan === 'double' || S.wan === 'mismatch' || A.net === 'vpn';
        node('isp', ispBad ? 'bad' : (n.udp === 'ok' ? 'good' : null), S.wan === 'cgnat' ? 'IP' : null);

        paintLine(A, res);

        // to-do, ranked by what blocks play first (QA m12)
        var ol = $('nttTodo'); ol.textContent = '';
        A.todos.forEach(function (t) {
            var li = document.createElement('li');
            li.dataset.sev = t.sev;
            li.textContent = tr(t.key, todoParams(t));
            ol.appendChild(li);
        });
        $('nttTodoTitle').textContent = S.shared ? tr('todo_title_shared') : tr('todo_title');
        $('nttTodoBox').hidden = false;

        details(res, A);
        $('nttDetailsBox').hidden = false;
        paintSummary(A, speak);
        paintRetest(A);
        $('nttHistSave').disabled = S.shared || !!res.stoppedLine;
        isp(); consoleOut(); paintWanOut();
    }

    function todoParams(t) {
        var p = {};
        if (t.p.region) p.city = tr('city_' + t.p.region);
        if (t.p.lossPct != null) p.loss = tr('m_pct', { v: fmt(t.p.lossPct, 1) });
        if (t.p.ms != null) p.ms = fmt(t.p.ms);
        if (t.p.why) p.why = has('line_why_' + t.p.why) ? tr('line_why_' + t.p.why) : tr('line_why_error');
        return p;
    }

    function paintLine(A, res) {
        var L = A.line, card = $('nttLine');
        var lineAttempted = res.n && res.n.udp === 'ok';
        card.hidden = !lineAttempted;
        if (!lineAttempted) return;
        var gEl = $('nttGrade');
        var qPrim = (res.q || [])[0], q0 = L.primary || (res.q || []).filter(function (q) { return q && q.ok; })[0];
        $('nttLineFinal').hidden = !q0;
        $('nttLineRetry').hidden = (!!q0 && !L.failed.length) || !!res.stoppedLine || S.shared;
        if (!q0) {
            card.dataset.state = 'failed';
            var why = qPrim && qPrim.why ? qPrim.why : 'error';
            gEl.textContent = res.stoppedLine ? tr('line_stopped') : tr('line_unknown');
            gEl.dataset.level = 'unknown';
            $('nttLineLive').textContent = res.stoppedLine ? tr('line_stopped_short') : tr('line_failed', { why: has('line_why_' + why) ? tr('line_why_' + why) : tr('line_why_error') });
            step('line', res.stoppedLine ? 'skip' : 'bad', gEl.textContent);
            link('lan', null); link('wan', null); link('net', null); node('server', null);
            return;
        }
        card.dataset.state = res.stoppedLine ? 'partial' : 'done';
        var g = L.grade, untrusted = !!res.stoppedLine || L.interrupted;
        gEl.textContent = res.stoppedLine ? tr('line_partial', { s: fmt(res.stoppedSecs), of: fmt(res.dur) }) : (L.interrupted ? tr('line_interrupted') : tr('line_' + g));
        gEl.dataset.level = untrusted ? 'unknown' : g;
        var ls = untrusted ? null : (g === 'good' ? 'good' : g === 'ok' ? 'ok' : g === 'bad' ? 'bad' : null);
        link('lan', ls); link('wan', ls); link('net', ls);
        node('server', 'good');
        step('line', ls || 'skip', gEl.textContent);
        $('nttLineLive').textContent = '';
        $('nttMLoss').textContent = pct(q0);
        $('nttMJit').textContent = tr('m_ms', { v: fmt(q0.jitterMs, 1) });
        $('nttMLat').textContent = ms(q0.latency.p50);
        $('nttMSpk').textContent = fmt(q0.spikes);
        $('nttMWhere').textContent = tr('metrics_for', { city: tr('city_' + q0.region) });
        var paths = $('nttPaths'); paths.textContent = '';
        if ((res.q || []).length > 1) {
            res.q.forEach(function (q) {
                var li = document.createElement('li');
                li.textContent = tr('path_row', { city: tr('city_' + q.region) }) + ' — ' + (q.ok ? ms(q.latency.p50) + ', ' + pct(q) : tr('line_failed_short'));
                if (q.ok && L.worstRegion === q.region && g !== 'good' && !untrusted) li.dataset.worst = '1';
                paths.appendChild(li);
            });
        }
        var lr = $('nttLoadRes'); lr.hidden = true;
        if (q0.loaded) {
            lr.hidden = false;
            if (L.loadMissed) lr.textContent = tr('load_missed_' + L.loadMissed);
            else if (L.bufferbloat) lr.textContent = tr('load_more', { ms: fmt(L.bufferbloat.ms) });
            else lr.textContent = tr('load_fine');
        }
        scheduleDraw();
    }

    function paintConsole(card, kind, val, levels, A) {
        var plain = val.plain || 'unknown', up = val.upnp;
        // a VPN's or a carrier's type is not this router's: no green/red judgement on it
        card.dataset.level = A && (A.net === 'vpn' || A.net === 'cellular') ? '' : (levels[plain] || '');
        card.querySelector('[data-v]').textContent = tr(kind + '_' + plain);
        var noteKey = kind + '_note_' + plain;
        var nk = A && (A.net === 'cellular' || A.net === 'vpn') ? 'note_' + A.net : (has(noteKey) ? noteKey : 'note_unknown');
        card.querySelector('[data-n]').textContent = tr(nk);
        var u = card.querySelector('[data-u]');
        if (up && up !== plain) { u.textContent = tr('with_upnp', { value: tr(kind + '_' + up) }); u.hidden = false; } else u.hidden = true;
    }

    function firstSentence(t) { var m = /^(.+?[.!?])(\s|$)/.exec(t); return m ? m[1] : t; }
    function paintSumChips(A) {
        $('nttSumPs5').textContent = tr('ps5_' + A.verdict.ps5.plain);
        $('nttSumXbox').textContent = tr('xbox_' + A.verdict.xbox.plain);
        var other = A.net === 'vpn' || A.net === 'cellular';
        $('nttSumPs5').dataset.level = other ? '' : (PS5_LEVEL[A.verdict.ps5.plain] || '');
        $('nttSumXbox').dataset.level = other ? '' : (XBOX_LEVEL[A.verdict.xbox.plain] || '');
    }
    function paintSummary(A, speak) {
        paintSumChips(A);
        var L = A.line, res = S.res;
        var lineTxt = !L.attempted ? '' : (res.stoppedLine ? tr('line_stopped') : (L.paths.length ? tr('sum_line', { grade: tr(L.interrupted ? 'line_interrupted' : 'line_' + L.grade) }) : tr('line_unknown')));
        $('nttSumLine').textContent = lineTxt; $('nttSumLine').hidden = !lineTxt;
        var first = A.todos[0];
        $('nttSumFirst').textContent = first ? firstSentence(tr(first.key, todoParams(first))) : '';
        $('nttSumFirstRow').hidden = !first;
        $('nttSummary').hidden = false;
        status(first && first.key === 'todo_good' ? tr('status_done_good') : tr('status_done'));
        if (speak) announce(tr('announce_done', { ps5: tr('ps5_' + A.verdict.ps5.plain), xbox: tr('xbox_' + A.verdict.xbox.plain), line: lineTxt || tr('line_unknown'), first: $('nttSumFirst').textContent }));
    }

    /* ---------- fix → retest: «было → стало» (the loop the to-do list is for) ---------- */
    function paintRetest(A) {
        var box = $('nttRetest'), prev = S.prev;
        box.hidden = true;
        if (S.shared || !prev || !S.res || S.res.stoppedLine || Date.now() - prev.at > LAST_TTL || prev.at === S.res.at) return;
        var rows = [];
        var cmp = function (label, a, b) { if (a && b && a !== b) rows.push(label + ': ' + a + ' → ' + b); };
        cmp('PS5', tr('ps5_' + prev.ps5), tr('ps5_' + A.verdict.ps5.plain));
        cmp('Xbox', tr('xbox_' + prev.xbox), tr('xbox_' + A.verdict.xbox.plain));
        if (prev.grade && A.line.grade !== 'unknown' && !A.line.interrupted) cmp(tr('retest_line'), tr('line_' + prev.grade), tr('line_' + A.line.grade));
        var when; try { when = new Date(prev.at).toLocaleString(loc(), { dateStyle: 'short', timeStyle: 'short' }); } catch (_) { when = ''; }
        $('nttRetestHead').textContent = tr('retest_head', { when: when });
        $('nttRetestBody').textContent = rows.length ? rows.join('\n') : tr('retest_same');
        box.hidden = false;
        var R = NatAdvice.RANK;
        var better = (R.xbox[A.verdict.xbox.plain] || 9) < (R.xbox[prev.xbox] || 9) || (R.ps5[A.verdict.ps5.plain] || 9) < (R.ps5[prev.ps5] || 9);
        feature('retest_compare', { improved: better ? 1 : 0, changed: rows.length ? 1 : 0 });
    }

    function complete(res, t0) {
        var A = S.A, v = A.verdict, q0 = A.line.primary, far = A.line.far;
        try {
            if (window.__aeToolComplete) window.__aeToolComplete({
                map: res.n.mapping && res.n.mapping.kind, filt: res.n.filtering && res.n.filtering.kind, hp: res.n.hairpin, udp: res.n.udp,
                ps5: v.ps5.plain, xbox: v.xbox.plain, grade: A.line.grade, net: A.net,
                loss: q0 ? Math.round(q0.lossPct * 100) / 100 : null, jit: q0 && q0.jitterMs != null ? Math.round(q0.jitterMs) : null,
                p50: q0 ? Math.round(q0.latency.p50) : null, spk: q0 ? q0.spikes : null, lost: q0 ? q0.lost : null, total: q0 ? q0.total : null, secs: q0 ? q0.seconds : null,
                eu_loss: far ? Math.round(far.lossPct * 100) / 100 : null, eu_p50: far ? Math.round(far.latency.p50) : null,
                bb_ms: A.line.bufferbloat ? Math.round(A.line.bufferbloat.ms) : null,
                load_mb: q0 && q0.loaded ? Math.round((q0.loadBytes || 0) / 1e6) : null, hidden_ms: res.hiddenMs || 0,
                sv_class: res.sv ? res.sv.httpClass : 'na', udp_class: res.sv ? res.sv.udpClass : 'na',
                region: res.region, dur: res.dur, load: res.load ? 1 : 0, conn: conn() || '', ios: IOS ? 1 : 0, run_n: S.runN,
                prev_ps5: S.prev ? S.prev.ps5 : null, prev_xbox: S.prev ? S.prev.xbox : null, todo1: A.todos[0] && A.todos[0].key, ms: Date.now() - t0
            });
        } catch (_) {}
        if (A.net !== 'normal') feature('net_warn', { type: A.net });
        sstore('set', LAST_KEY, { at: res.at, ps5: v.ps5.plain, xbox: v.xbox.plain, grade: A.line.grade !== 'unknown' && !A.line.interrupted ? A.line.grade : null });
    }

    function details(res, A) {
        var n = res.n || {}, dl = $('nttDetails'); dl.textContent = '';
        var add = function (k, val) { if (val == null || val === '') return; var dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = tr(k); dd.textContent = val; dl.appendChild(dt); dl.appendChild(dd); };
        add('d_udp', tr('st_udp_' + (n.udp || 'ok')));
        if (n.mapping) add('d_map', tr('st_map_' + n.mapping.kind) + (has('d_rfc_map_' + n.mapping.kind) ? ' — ' + tr('d_rfc_map_' + n.mapping.kind) : ''));
        if (n.mapping && n.mapping.portPreserved != null) add('d_port_pres', n.mapping.portPreserved ? tr('d_yes') : tr('d_no'));
        if (n.filtering) add('d_filter', tr('st_filter_' + n.filtering.kind) + (has('d_rfc_filter_' + n.filtering.kind) ? ' — ' + tr('d_rfc_filter_' + n.filtering.kind) : ''));
        if (n.hairpin && n.mapping && n.mapping.kind !== 'none') add('d_hairpin', tr('st_hairpin_' + n.hairpin));
        add('d_ipv6', n.ipv6 == null ? tr('d_unknown') : (n.ipv6 ? tr('d_yes') : tr('d_not_found')));
        add('d_public_ip', n.publicIp);
        if (res.sv) { add('d_http_ip', res.sv.httpIp); add('d_isp', ispOrg(res.sv)); }
        add('d_network', tr('d_net_' + A.net));
        if (n.stun && n.stun.length) add('d_servers', n.stun.map(function (s) { return s.ok ? tr('d_ms_from', { host: s.host, ms: fmt(s.ms) }) : tr('d_no_answer', { host: s.host }); }).join('; '));
    }

    function restoreIdle() {
        root.dataset.phase = 'idle';
        ['nttPs5', 'nttXbox'].forEach(function (id) {
            var c = $(id); c.dataset.level = '';
            c.querySelector('[data-v]').textContent = '—';
            c.querySelector('[data-n]').textContent = tr('card_idle');
            c.querySelector('[data-u]').hidden = true;
        });
        $('nttLine').hidden = false; $('nttLine').dataset.state = 'idle'; $('nttLineLive').textContent = tr('line_idle'); $('nttLineFinal').hidden = true;
        $('nttGrade').textContent = ''; $('nttLineRetry').hidden = true; $('nttLoadRes').hidden = true; $('nttPaths').textContent = '';
        $('nttTodoBox').hidden = true; $('nttDetailsBox').hidden = true; $('nttSummary').hidden = true; $('nttRetest').hidden = true;
        $('nttNetNote').hidden = true;
        chart.series = {}; drawChart();
        isp();
    }

    var lineRetry = $('nttLineRetry');
    if (lineRetry) lineRetry.addEventListener('click', function () { feature('line_retry'); start(); });

    /* ---------- side tool: what the console shows ---------- */
    root.querySelectorAll('[data-console]').forEach(function (b) {
        b.addEventListener('click', function () {
            S.consolePick = b.dataset.console;
            root.querySelectorAll('[data-console]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            var key = consoleOut();
            feature('console_reading', { v: S.consolePick, ps5: S.A ? S.A.verdict.ps5.plain : 'na', xbox: S.A ? S.A.verdict.xbox.plain : 'na', cmp: key });
        });
    });
    function consoleOut() {
        var out = $('nttConsoleOut'), pick = S.consolePick; if (!pick || !out) return null;
        var key = NatAdvice.compareConsole(pick, S.A);
        out.textContent = tr(key); out.hidden = false;
        return key;
    }

    /* ---------- side tool: WAN address ---------- */
    var wanForm = $('nttWanForm');
    if (wanForm) wanForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = $('nttWan').value;
        // compare with THIS visitor's own run only — a shared result's address is someone else's (QA m13)
        var pub = !S.shared && S.res && S.res.n ? S.res.n.publicIp : '';
        var r = NatAdvice.wanApply(val, pub);
        S.wanOut = { kind: r.kind, ip: pub };
        if (!S.shared) { S.wan = r.state; S.wanValue = r.state ? (r.ip || val.trim().replace(/,/g, '.')) : ''; }
        paintWanOut();
        feature('wan_check', { v: r.kind });
        if (S.res && !S.shared) render();
    });
    function paintWanOut() {
        var out = $('nttWanOut'); if (!out || !S.wanOut) return;
        out.textContent = tr('wan_' + S.wanOut.kind, { ip: S.wanOut.ip || '—' }); out.hidden = false;
    }

    /* ---------- side tool: port rules ---------- */
    var pConsole = $('nttPortsConsole'), pIp = $('nttPortsIp'), pGta = $('nttPortsGta');
    if (settings && pConsole) settings.bind(SLUG, pConsole, 'console', 'ps5');
    function ports() {
        var la = NatProbe.lanAddress(pIp.value);
        var rows = NatProbe.portRules(pConsole.value, pIp.value, pGta.checked), body = $('nttPortsBody');
        body.textContent = '';
        rows.forEach(function (r) {
            var tr_ = document.createElement('tr');
            [r.proto, r.ports + (r.gta ? ' (' + tr('ports_gta_tag') + ')' : ''), r.to || tr('ports_any_ip')].forEach(function (c) { var td = document.createElement('td'); td.textContent = c; tr_.appendChild(td); });
            body.appendChild(tr_);
        });
        var warn = $('nttPortsWarn');
        var wk = { invalid: 'ports_bad_ip', not_lan: 'ports_not_lan', router: 'ports_router_ip' }[la.kind];
        if (wk) { warn.textContent = tr(wk); warn.hidden = false; } else warn.hidden = true;
        return { rows: rows, la: la };
    }
    [pConsole, pIp, pGta].forEach(function (el) { if (el) { el.addEventListener('input', ports); el.addEventListener('change', ports); } });
    if (pConsole && window.NatProbe) ports();
    var pCopy = $('nttPortsCopy');
    if (pCopy) pCopy.addEventListener('click', function () {
        var x = ports();
        copy(x.rows.map(function (r) { return r.proto + ' ' + r.ports + ' → ' + (r.to || tr('ports_any_ip')) + (r.gta ? ' (' + tr('ports_gta_tag') + ')' : ''); }).join('\n'));
        feature('ports_copy', { c: pConsole.value, gta: pGta.checked ? 1 : 0, lan: x.la.kind });
    });

    /* ---------- side tool: ISP report ---------- */
    function shareUrl() {
        var r = S.res; if (!r || !r.n) return location.origin + location.pathname;
        var pack = { v: 2, a: r.at, rg: r.region, u: r.n.udp, m: r.n.mapping && r.n.mapping.kind, f: r.n.filtering && r.n.filtering.kind, h: r.n.hairpin, ip: r.n.publicIp,
            w: S.wan, i6: r.n.ipv6, o: r.sv ? ispOrg(r.sv) : '', hc: r.sv && r.sv.httpClass, uc: r.sv && r.sv.udpClass, df: r.sv && r.sv.differs ? 1 : 0, d: r.dur,
            q: (r.q || []).filter(function (x) { return x.ok; }).map(function (x) { return [x.region, +x.lossPct.toFixed(3), x.lossUpperPct == null ? null : +x.lossUpperPct.toFixed(2), x.jitterMs == null ? null : +x.jitterMs.toFixed(1), Math.round(x.latency.p50), x.spikes, x.total, x.seconds, x.latency.n]; }) };
        try { return location.origin + location.pathname + '#r=' + btoa(unescape(encodeURIComponent(JSON.stringify(pack)))).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_'); }
        catch (_) { return location.origin + location.pathname; }
    }
    /* The provider of the address STUN saw (the one the letter is about). When the site's address differs
       (Private Relay, a proxy), the site-side org is someone else's — 04.11 the letter named Apple. */
    function ispOrg(sv) { return sv ? (sv.udpOrg || (sv.differs ? '' : sv.org) || '') : ''; }
    function natLine(r, A) {
        var v = A.verdict;
        return 'PS5 — ' + tr('ps5_' + v.ps5.plain) + ', Xbox — ' + tr('xbox_' + v.xbox.plain) +
            (r.n.mapping && r.n.mapping.kind !== 'none' ? ' (' + tr('st_map_' + r.n.mapping.kind) + (r.n.filtering ? '; ' + tr('st_filter_' + r.n.filtering.kind) : '') + ')' : ' (' + tr('st_udp_' + r.n.udp) + ')');
    }
    function letter() {
        var r = S.res, A = S.A; if (!r || !A || !A.asks) return '';
        var lines = [tr('isp_greeting'), ''];
        var date; try { date = new Date(r.at).toLocaleString(loc(), { dateStyle: 'long', timeStyle: 'short', timeZoneName: 'short' }); } catch (_) { date = new Date(r.at).toISOString(); }
        lines.push(tr('isp_lead', { date: date }));
        if (r.n.publicIp) lines.push('— ' + tr('isp_ip', { v: r.n.publicIp + (r.sv && ispOrg(r.sv) ? ' (' + ispOrg(r.sv) + ')' : '') }));
        lines.push('— ' + tr('isp_nat', { v: natLine(r, A) }));
        if (S.wanValue && S.wan) lines.push('— ' + tr('isp_wan', { v: S.wanValue }));
        (r.q || []).forEach(function (q) {
            if (!q.ok) return;
            lines.push('— ' + tr('isp_path', { city: tr('city_' + q.region), loss: pct(q), lost: fmt(q.lost), total: fmt(q.total), jitter: tr('m_ms', { v: fmt(q.jitterMs, 1) }), latency: ms(q.latency.p50), secs: fmt(q.seconds) }));
        });
        lines.push('');
        A.asks.forEach(function (k) { lines.push(tr(k)); });
        lines.push('', tr('isp_signature', { url: shareUrl() }));
        return lines.join('\n');
    }
    function isp() {
        var el = $('nttIspText'), btns = ['nttIspCopy', 'nttIspPdf', 'nttIspShare'];
        var ok = !!(S.res && S.A && S.A.asks);
        if (el) el.textContent = ok ? letter() : (S.res && S.A && !S.A.asks ? tr('isp_not_applicable') : tr('isp_need_run'));
        btns.forEach(function (id) { var b = $(id); if (b) b.disabled = !ok; });
    }
    var ispCopy = $('nttIspCopy');
    if (ispCopy) ispCopy.addEventListener('click', function () { if (S.A && S.A.asks) copy(letter()).then(function (ok) { feature('isp_copy', { ok: ok ? 1 : 0 }); }); });
    var ispShare = $('nttIspShare');
    if (ispShare) ispShare.addEventListener('click', function () {
        if (!S.res) return;
        var url = shareUrl();
        if (navigator.share) {
            navigator.share({ url: url, title: document.title }).then(function () { feature('isp_share', { via: 'share', ok: 1 }); }, function (e) {
                if (e && e.name === 'AbortError') { feature('isp_share', { via: 'share', ok: 0, cancel: 1 }); return; }
                // a share sheet that refused (no user activation left, iOS) falls back to the clipboard
                copy(url).then(function (ok) { if (ok) toast(tr('link_copied'), 'success'); feature('isp_share', { via: 'copy_fallback', ok: ok ? 1 : 0 }); });
            });
        } else copy(url).then(function (ok) { if (ok) toast(tr('link_copied'), 'success'); feature('isp_share', { via: 'copy', ok: ok ? 1 : 0 }); });
    });
    var ispPdf = $('nttIspPdf');
    if (ispPdf) ispPdf.addEventListener('click', function () {
        if (!S.A || !S.A.asks) return;
        var t0 = Date.now();
        var box = pdfDoc();
        var go = function () {
            window.__generatePDF({ element: box, filename: 'nat-type-test.pdf', strings: { genError: tr('pdf_failed') } })
                .then(function (r) { feature('isp_pdf', { ok: r && r.ok ? 1 : 0, ms: Date.now() - t0, err: r && !r.ok ? r.code : null }); if (!r || !r.ok) toast(tr('pdf_failed'), 'warning'); });
        };
        if (window.__generatePDF) go();
        else {
            var tries = 0, iv = setInterval(function () {
                if (window.__generatePDF || ++tries > 40) { clearInterval(iv); if (window.__generatePDF) go(); else { toast(tr('pdf_failed'), 'warning'); feature('isp_pdf', { ok: 0, err: 'no_lib' }); } }
            }, 150);
        }
    });
    /* The PDF page: a document of its own, not a capture of the on-screen card. report-pdf.js lays
       the copy out at the page's inner width, so 16 px text stays ~12 pt on paper and the long link
       wraps. Before 04.11 the on-screen box was captured and came out at 6–7 pt with the link cut
       off (QA M11). Styles: .ntt-pdf in the blade (top-level selectors — the copy lives in <body>). */
    function pdfDoc() {
        var r = S.res, A = S.A;
        var d = document.createElement('div');
        d.className = 'ntt-pdf';
        var h = document.createElement('h1'); h.textContent = tr('isp_pdf_title'); d.appendChild(h);
        var dl = document.createElement('dl');
        var row = function (k, v) { var dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = k; dd.textContent = v; dl.appendChild(dt); dl.appendChild(dd); };
        var date; try { date = new Date(r.at).toLocaleString(loc(), { dateStyle: 'long', timeStyle: 'short', timeZoneName: 'short' }); } catch (_) { date = ''; }
        row(tr('pdf_when'), date);
        row('PS5', tr('ps5_' + A.verdict.ps5.plain));
        row('Xbox', tr('xbox_' + A.verdict.xbox.plain));
        (r.q || []).forEach(function (q) { if (q.ok) row(tr('path_row', { city: tr('city_' + q.region) }), pct(q) + ', ' + tr('m_jitter') + ' ' + tr('m_ms', { v: fmt(q.jitterMs, 1) }) + ', ' + ms(q.latency.p50)); });
        d.appendChild(dl);
        var pre = document.createElement('div'); pre.className = 'ntt-pdf-letter'; pre.textContent = letter(); d.appendChild(pre);
        return d;
    }

    /* ---------- side tool: history (numbers, formatted at render — QA m15) ---------- */
    var HKEY = 'ntt_history_v2';
    function hLoad() { var l = sstore('get', HKEY); return Array.isArray(l) ? l : []; }
    function hSave(list) { return sstore('set', HKEY, list.slice(0, 20)); }
    function hRender() {
        var list = hLoad(), body = $('nttHistList');
        body.textContent = '';
        list.forEach(function (h, i) {
            var li = document.createElement('li');
            var when; try { when = new Date(h.at).toLocaleString(loc(), { dateStyle: 'short', timeStyle: 'short' }); } catch (_) { when = ''; }
            var head = document.createElement('div'); head.className = 'ntt-h-head';
            var b = document.createElement('b'); b.textContent = h.label || tr('hist_unlabelled'); head.appendChild(b);
            var tm = document.createElement('time'); tm.textContent = when; head.appendChild(tm);
            li.appendChild(head);
            var body2 = document.createElement('div'); body2.className = 'ntt-h-body';
            var q = h.q;
            body2.textContent = 'PS5 ' + tr('ps5_' + h.ps5) + ', Xbox ' + tr('xbox_' + h.xbox) +
                (q ? '; ' + tr('m_loss') + ' ' + (q.lost === 0 && q.lossUpperPct != null ? tr('m_loss_upper', { v: fmt(q.lossUpperPct, 1) }) : tr('m_pct', { v: fmt(q.lossPct, 2) })) +
                     ', ' + tr('m_jitter') + ' ' + tr('m_ms', { v: fmt(q.jitterMs, 1) }) + ', ' + ms(q.p50) : '');
            li.appendChild(body2);
            var rm = document.createElement('button');
            rm.type = 'button'; rm.className = 'tc-btn ghost sm ntt-h-rm'; rm.textContent = tr('hist_remove');
            rm.setAttribute('aria-label', tr('hist_remove') + ': ' + (h.label || when));
            rm.addEventListener('click', function () { var l = hLoad(); l.splice(i, 1); if (hSave(l)) { feature('history_remove', { n: l.length }); hRender(); } else toast(tr('hist_save_failed'), 'warning'); });
            li.appendChild(rm);
            body.appendChild(li);
        });
        body.hidden = !list.length; $('nttHistEmpty').hidden = !!list.length; $('nttHistClear').hidden = !list.length;
    }
    root.querySelectorAll('[data-hist-label]').forEach(function (b) {
        b.addEventListener('click', function () { $('nttHistLabel').value = b.dataset.histLabel; $('nttHistLabel').focus(); });
    });
    var hForm = $('nttHistForm');
    if (hForm) hForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = S.res, A = S.A; if (!r || !A || S.shared || r.stoppedLine) return;
        var q = A.line.primary;
        var list = hLoad();
        list.unshift({
            at: r.at, label: ($('nttHistLabel').value || '').trim().slice(0, 40), ps5: A.verdict.ps5.plain, xbox: A.verdict.xbox.plain, grade: A.line.grade,
            q: q ? { lossPct: q.lossPct, lossUpperPct: q.lossUpperPct, lost: q.lost, jitterMs: q.jitterMs, p50: q.latency.p50 } : null
        });
        if (hSave(list)) {
            hRender(); toast(tr('hist_saved'), 'success'); $('nttHistSave').disabled = true;
            feature('history_save', { n: list.length, labelled: $('nttHistLabel').value.trim() ? 1 : 0 });
        } else toast(tr('hist_save_failed'), 'warning');
    });
    var hClear = $('nttHistClear'), clearArmed = 0;
    if (hClear) hClear.addEventListener('click', function () {
        if (Date.now() - clearArmed > 4000) { clearArmed = Date.now(); hClear.textContent = tr('hist_clear_confirm'); return; }
        clearArmed = 0; hClear.textContent = tr('hist_clear');
        if (hSave([])) { feature('history_clear'); hRender(); } else toast(tr('hist_save_failed'), 'warning');
    });
    hRender();

    /* ---------- the five tools: accordions on narrow, tabs on a wide workspace ---------- */
    var tools = Array.prototype.slice.call(root.querySelectorAll('.ntt-tool'));
    var tabs = $('nttTabs'), wideTabs = false, activeTool = tools[0] && tools[0].dataset.tool;
    tools.forEach(function (d) {
        d.addEventListener('toggle', function () {
            if (wideTabs) return;
            d.dataset.userOpen = d.open ? '1' : '';             // what the person opened, restored after tabs
            if (d.open) feature('fold_open', { id: d.dataset.tool });
        });
    });
    if (tabs) tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab]'); if (!b) return;
        activeTool = b.dataset.tab; paintTabs(); feature('fold_open', { id: activeTool, via: 'tab' });
    });
    if (tabs) tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var ids = tools.map(function (d) { return d.dataset.tool; }), i = ids.indexOf(activeTool);
        var dir = (e.key === 'ArrowRight') !== (document.documentElement.dir === 'rtl') ? 1 : -1;
        activeTool = ids[(i + dir + ids.length) % ids.length]; paintTabs();
        var nb = tabs.querySelector('[data-tab="' + activeTool + '"]'); if (nb) nb.focus();
        e.preventDefault();
    });
    function paintTabs() {
        tabs.querySelectorAll('[data-tab]').forEach(function (b) { var on = b.dataset.tab === activeTool; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; b.classList.toggle('on', on); });
        tools.forEach(function (d) { var on = d.dataset.tool === activeTool; d.open = true; d.hidden = !on; });
    }
    function layoutMode() {
        var wide = root.clientWidth >= 1500;
        if (wide === wideTabs) return;
        wideTabs = wide; root.dataset.tabs = wide ? '1' : '0';
        if (tabs) tabs.hidden = !wide;
        if (wide) paintTabs();
        else tools.forEach(function (d) { d.hidden = false; d.open = d.dataset.userOpen === '1'; });
        scheduleDraw();
    }
    if (window.ResizeObserver) new ResizeObserver(function () { layoutMode(); scheduleDraw(); }).observe(root);
    document.addEventListener('wide-workspace:change', layoutMode);
    layoutMode();

    /* ---------- a result opened from a link ---------- */
    function leaveShared() { S.shared = false; $('nttShared').hidden = true; S.wan = null; S.wanValue = ''; }
    function readShared() {
        var m = /#r=([A-Za-z0-9+/_-]+)/.exec(location.hash || ''); if (!m) return;
        try {
            var p = JSON.parse(decodeURIComponent(escape(atob(m[1].replace(/-/g, '+').replace(/_/g, '/')))));
            var res = {
                at: p.a, region: p.rg, dur: p.d || 30,
                n: { udp: p.u, tcpRelay: true, publicIp: p.ip || '', mapping: p.m ? { kind: p.m } : null, filtering: p.f ? { kind: p.f } : null, hairpin: p.h || 'unknown', ipv6: p.i6 == null ? null : !!p.i6, rtc: true, stun: [] },
                sv: { org: p.o || '', udpOrg: p.o || '', httpIp: '', differs: !!(p.df || p.vp), httpClass: p.hc || '', udpClass: p.uc || '' },
                q: (p.q || []).map(function (x) { return { region: x[0], ok: true, lossPct: x[1], lossUpperPct: x[2], jitterMs: x[3], latency: { p50: x[4], n: x[8] || Math.max(1, (x[7] || 30) * 10) }, spikes: x[5], total: x[6], seconds: x[7], lost: Math.round(x[1] * x[6] / 100) }; })
            };
            S.shared = true; S.wan = p.w || null; S.wanValue = ''; S.res = res; S.prev = null;
            var date; try { date = new Date(p.a).toLocaleString(loc()); } catch (_) { date = ''; }
            var b = $('nttShared'); b.textContent = tr('shared_banner', { date: date }); b.hidden = false;
            $('nttSteps').hidden = true;
            render();
            setRunning(false);
            feature('shared_open');
        } catch (_) {}
    }
    window.addEventListener('hashchange', function () { if (!S.running) readShared(); });

    /* ---------- go ---------- */
    restoreIdle();
    readShared();
    if (window.__earlyAction) window.__earlyAction.claim('nat-type-test', function () { start(); });
})();
